import React from "react";
import { TerminalSquare } from "lucide-react";
import { formatReportDate } from "../../utils";

function RemediationOutputField({ output, startTime, title }) {
    const getFallbackMessage = () => {
        switch (title) {
            case "Previous Output":
                return "No previous validation output recorded.";
            case "Remediation Output":
                return "Remediation completed but returned no output.";
            case "Later Output":
                return "Post-remediation validation was not executed.";
            default:
                return "No output recorded for this step.";
        }
    };

    const outputText = output === null || output === undefined || String(output).trim() === ""
        ? getFallbackMessage()
        : String(output);

    const getDateTimeFormat = (timestamp) => {
        const numericTimestamp = Number(timestamp);

        if (!Number.isFinite(numericTimestamp) || numericTimestamp <= 0) {
            return "";
        }

        return formatReportDate(numericTimestamp);
    };

    return (
        <div className="oct-remediation-output-modal__section">
            <div className="oct-remediation-output-modal__section-heading">
                <div className="oct-remediation-output-modal__chip">
                    <TerminalSquare size={16} />
                    <span>{title}</span>
                </div>
                <p className="oct-remediation-output-modal__section-date">
                    Date: {getDateTimeFormat(startTime) || "N/A"}
                </p>
            </div>

            <textarea
                className="oct-remediation-output-modal__textarea"
                aria-label={`${title} output`}
                value={outputText}
                readOnly
            />
        </div>
    );

}

export default RemediationOutputField;
